export default __webpack_public_path__ + "images/extra-install-tick.623767218ff683435916e7b60b6d9ae1.svg";